import type { OneToTwenty, ScaleSelectorProps } from "@qendo/profile/journal";
import { ScaleType } from "@qendo/trackables";
import { FieldGroup } from "~/components/form/FieldGroup";
import { RangeInput } from "~/components/form/RangeInput";

export type OneToTwentySelectorProps = ScaleSelectorProps<ScaleType.twenty>;

const clamp = (input: number | null | undefined): OneToTwenty | 0 => {
    return Math.max(0, Math.min(20, Math.abs(input ?? 0))) as OneToTwenty | 0;
};

export const OneToTwentySelector = ({ value, onUpdateScale, zIndex, ...rangeProps }: OneToTwentySelectorProps) => {
    const scale = clamp(value?.value);

    const changeScale = (val: number) => {
        scale !== val &&
            onUpdateScale({
                type: ScaleType.twenty,
                value: val === 0 ? null : (clamp(val) as OneToTwenty),
            });
    };

    return (
        <FieldGroup zIndex={zIndex}>
            <RangeInput {...rangeProps} min={1} max={20} step={1} value={scale} onValueChange={changeScale} />
        </FieldGroup>
    );
};
